import { HandlerAbstract } from './handlerAbstract'
import { WrapperAbstract } from '@/resolvers/assignments/wrapperAbstract'
import { ObjectTemplate } from '@cybertale/interface'

export class AddHandler extends HandlerAbstract {
}
